// Verhindert Scrollen der Hauptseite wenn Warenkorb offen ist
document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.querySelector('cart-drawer');
  
  if (!cartDrawer) return;
  
  // Observer für Drawer-Änderungen
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class') {
        const isActive = cartDrawer.classList.contains('active');
        
        if (isActive) {
          // Drawer ist offen - Seite blockieren
          document.body.style.overflow = 'hidden';
          document.body.style.position = 'fixed';
          document.body.style.width = '100%';
          document.body.style.top = `-${window.scrollY}px`;
        } else {
          // Drawer ist zu - Seite freigeben
          const scrollY = document.body.style.top;
          document.body.style.overflow = '';
          document.body.style.position = '';
          document.body.style.width = '';
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
      }
    });
  });
  
  observer.observe(cartDrawer, { attributes: true });
  
  // Verhindert Touch-Events außerhalb des Drawers
  document.addEventListener('touchmove', function(e) {
    if (cartDrawer.classList.contains('active')) {
      const drawerInner = cartDrawer.querySelector('.drawer__inner');
      if (drawerInner && !drawerInner.contains(e.target)) {
        e.preventDefault();
      }
    }
  }, { passive: false });
});